import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/shared/PageHeader";
import { Seo } from "@/components/shared/Seo";

export default function NotFound() {
  return (
    <section data-testid="not-found">
      <Seo title="Fann ikkje sida" description="Sida du leitar etter finst ikkje på Halsnøy Kulturhus." noindex />
      <Container className="min-h-[60vh] py-20">
        <p className="t-mono text-muted-foreground">404 – fann ikkje sida</p>
        <div className="mt-4">
          <h1 className="t-h1 max-w-3xl text-balance">Her var det ingenting – enno.</h1>
          <p className="t-lead mt-7 max-w-xl text-muted-foreground text-pretty">Sida du leitar etter finst ikkje, eller har flytta på seg. Kanskje du vil sjå romma eller kalenderen i staden?</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Button asChild size="lg" data-testid="not-found-home-link"><Link to="/"><ArrowLeft className="h-4 w-4" /> Til framsida</Link></Button>
            <Button asChild variant="outline" size="lg" data-testid="not-found-rooms-link"><Link to="/rom">Sjå romma <ArrowUpRight className="h-4 w-4" /></Link></Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
